import React from 'react';
import styles from './LandingPage.module.css';

function objectiveText(obj) {
  return obj.title ?? obj.objective ?? obj.text ?? '';
}

export default function LearningObjectives({ items = [], language = 'en' }) {
  if (!items.length) return null;

  const lang = String(language).toLowerCase();
  const eyebrow = lang === 'es' ? 'Lo que aprenderás' : 'What You\'ll Learn';
  const title = lang === 'es' ? 'Objetivos del evento' : 'Learning Objectives';

  return (
    <section className={`${styles.section} ${styles.sectionAlt}`}>
      <div className={styles.container}>
        <header className={styles.sectionHeader}>
          <p className={styles.sectionEyebrow}>{eyebrow}</p>
          <h2 className={styles.sectionTitle}>{title}</h2>
        </header>
        <div className={styles.objectivesGrid}>
          {items.map((obj, idx) => (
            <div key={obj.id ?? idx} className={styles.objectiveCard}>
              <div className={styles.objectiveNum}>{String(idx + 1).padStart(2, '0')}</div>
              <p className={styles.objectiveText}>{objectiveText(obj)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
